import styles from './sortDropDown.scss';
import React, { Component } from 'react';

export default class SortDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSortOption: app.appUtil.getAppConstants().SORT_CRITERIA.ACCNUM_ASC,
            sortDropDownValue:"Customer Account (ascending)",isOpenDropDown:false
        };
        this.popupRef = React.createRef();
        this.downarrowblack = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_chev_gdown.svg';
    }
    componentDidMount() {
        document.addEventListener('click', this.handClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handClickOutside);
    }
    handClickOutside = (event) => {
        if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
            { this.setState({ isOpenDropDown: false }); }
        }
    }
    handleClickSortOption = () => {
        if(window.location.pathname === '/mysce/settings'){
            let events = { alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'sort', search:false}, hash = window.location.hash === '#accounts' ? 'accounts' : 'billing_payments';
            app.analyticsService.addPageLevelData('eventCapturing', events);
            this.setState({ isOpenDropDown: !this.state.isOpenDropDown },()=>{
                window.aUtils ? window.aUtils.sendAAEvent("sort", `settings|${hash}|none|sort|page|${this.state.isOpenDropDown ? 'expand': 'collapse'}`) : null; 
            });
        }else{
            this.setState({ isOpenDropDown: !this.state.isOpenDropDown });

        }      
    }
    handleDropDownValue = (sort, value) => {
        if(window.location.pathname === '/mysce/settings'){
            let events = { alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'sort', search:false}, hash = window.location.hash === '#accounts' ? 'accounts' : 'billing_payments';
        app.analyticsService.addPageLevelData('eventCapturing', events);
        setTimeout(function() {
            window.aUtils ? window.aUtils.sendAAEvent("sort", `settings|${hash}|none|sort|page|${value}`) : null;
            }
        ,1500);
        }
        this.setState({ selectedSortOption: sort, sortDropDownValue: value });
        // this.props.handleSort(sort);
        this.props.sortAccount(sort);
      }
    render() {
        return (
            <div className={styles.sceSortBlock}  tabIndex={"0"} onKeyDown={(e)=>{e.key==="Enter"?this.handleClickSortOption():null;}} ref={this.popupRef} onClick={this.handleClickSortOption}>
                <div className={styles.sceSortBlockMngAcnt}>Sort:</div>
                <div className={styles.sceSortDropDownBlock}>
                    <div className={styles.sceSortSelectedValue}>{this.state.sortDropDownValue}</div>
                    {
                        this.state.isOpenDropDown && <div className={styles.sceSortDropDownBox}>
                            <div className={[styles.sceSortDropDownOptions, this.state.selectedSortOption === "ASC" ? styles.sceSOrtCloredDiv : ""].join(" ")}  tabIndex={"0"} onKeyDown={(e)=>{e.key==="Enter"?this.handleDropDownValue("ASC", "Customer Account (ascending)"):null;}} onClick={() => this.handleDropDownValue("ASC", "Customer Account (ascending)")}>
                                <div className={styles.sceSortDropDownOption}>Customer Account (ascending)</div>
                                {this.state.selectedSortOption === "ASC" ? <div className={styles.sceSortDrpDownCheckIcon}><img src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_check.svg'} alt='check' /></div> : null}
                            </div>
                            <div className={[styles.sceSortDropDownOptions, this.state.selectedSortOption === "DESC" ? styles.sceSOrtCloredDiv : ""].join(" ")} onClick={() => this.handleDropDownValue("DESC", "Customer Account (descending)")}  tabIndex={"0"} onKeyDown={(e)=>{e.key==="Enter"?this.handleDropDownValue("DESC", "Customer Account (descending)"):null;}}>
                                <div className={styles.sceSortDropDownOption}>Customer Account (descending)</div>
                                {this.state.selectedSortOption === "DESC" ? <div className={styles.sceSortDrpDownCheckIcon}><img src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_check.svg'} alt='check' /></div> : null}
                            </div>
                        </div>
                    }
                </div>
                <div className={styles.sceSortArrowBtn}>
                    <img alt='arrow' src={this.downarrowblack} className={this.state.isOpenDropDown ? styles.sceSortArrowBtnReverse : styles.sceSortArrowBtnDown} />
                </div>
            </div>
        );
    }
}
